import {Component, Input, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {getImageURL} from '../../../../features/core/store/core.actions';
import {Observable} from 'rxjs';
import {selectImageURL} from '../../../../features/core/store/core.selectors';

import {IconsEnum} from '../../../shared-icons/models/icons.enum';
import {ModalControllerService} from '../../../../shared/shared-services/overlay/modal-controller.service';
import {DEFAULT_LOADER_INFINITE} from '../../../../shared/shared-module-ui/models/animations';

@Component({
  selector: 'app-freshness-explanation',
  templateUrl: './data-freshness-explanation.component.html',
  styleUrls: ['./data-freshness-explanation.component.scss'],
  standalone: false,
})
export class DataFreshnessExplanationComponent implements OnInit {

  isImageLoading = true;
  imageURL$: Observable<string>;
  imageUrl: string;

  @Input() imageURL: string;

  protected readonly icons = IconsEnum;
  protected readonly animation = DEFAULT_LOADER_INFINITE;

  constructor(
    private modalController: ModalControllerService,
    private readonly store: Store,
  ) {
  }

  ngOnInit(): void {
    const image = 'gallix_cloud_flow_chart.svg';
    this.store.dispatch(getImageURL({path: `/site_media/help/data_freshness/${image}`, image}));

    this.imageURL$ = this.store.select(selectImageURL(image));
    this.imageURL$.subscribe((image: string): void => {
      this.imageUrl = image;
    });
  }

  onImageLoad(): void {
    this.isImageLoading = false;
  }

  onButtonPress(): void {
    void this.modalController
      .dismiss()
      .then();
  }

}
